import React, { useEffect, useState } from 'react';
import { Save, Plus, Trash2, AlertCircle } from 'lucide-react';

const AdminTarifsCerfaTicgn = () => {
  const [tarifs, setTarifs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [source, setSource] = useState('');
  const [newAnnee, setNewAnnee] = useState('');

  useEffect(() => { fetchTarifs(); }, []);

  const fetchTarifs = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/tarifs-cerfa-ticgn`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setTarifs(data.tarifs || []);
        setSource(data.source || '');
      }
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/tarifs-cerfa-ticgn`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ tarifs })
      });
      if (res.ok) { setSource('database'); alert('Tarifs CERFA TICGN sauvegardes'); }
    } catch (err) { alert('Erreur'); }
    finally { setSaving(false); }
  };

  const updateTarif = (index, value) => {
    const updated = [...tarifs];
    updated[index] = { ...updated[index], tarif: parseFloat(value) || 0 };
    setTarifs(updated);
  };

  const addAnnee = () => {
    if (!newAnnee || tarifs.some(t => t.annee === newAnnee)) return;
    setTarifs([...tarifs, { annee: newAnnee, tarif: 8.37 }].sort((a, b) => a.annee.localeCompare(b.annee)));
    setNewAnnee('');
  };

  const removeAnnee = (index) => { setTarifs(tarifs.filter((_, i) => i !== index)); };

  if (loading) return <div className="flex items-center justify-center h-64"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#FF6B35]"></div></div>;

  return (
    <div data-testid="admin-tarifs-cerfa-ticgn-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-heading font-semibold text-[#191D1E]">Tarif CERFA officiel TICGN</h1>
          <p className="text-[#687175] text-sm mt-1">Tarif flat utilise pour le calcul du ratio d'eligibilite TICGN (CERFA / VAC)</p>
        </div>
        <button onClick={handleSave} disabled={saving} className="flex items-center gap-2 bg-[#FF6B35] hover:bg-[#e55e2d] text-white font-medium py-2.5 px-5 rounded-lg disabled:opacity-50" data-testid="save-tarifs-cerfa-ticgn-btn">
          <Save className="w-4 h-4" /> {saving ? 'Sauvegarde...' : 'Sauvegarder'}
        </button>
      </div>

      <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6 flex items-start gap-3">
        <AlertCircle className="w-5 h-5 text-[#FF6B35] mt-0.5 flex-shrink-0" />
        <div className="text-sm text-orange-800">
          <p className="font-medium mb-1">Tarif de reference TICGN</p>
          <p>Ce tarif est utilise <strong>uniquement</strong> pour calculer le ratio d'eligibilite :</p>
          <p className="font-mono mt-1">Ratio = (Conso MWh x Tarif CERFA TICGN) / Valeur Ajoutee Comptable</p>
          <p className="mt-1">Le seuil d'eligibilite est de <strong>0,5%</strong> de la VAC (pour les motifs soumis au ratio).</p>
        </div>
      </div>

      {source === 'default' && (
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4 text-sm text-amber-800">
          Valeurs par defaut (8,37 EUR/MWh). Sauvegardez pour personnaliser.
        </div>
      )}

      <div className="bg-white border border-[#BFC6CC] rounded-lg overflow-hidden">
        <table className="w-full">
          <thead className="bg-[#F5F6F9]">
            <tr>
              <th className="text-left px-6 py-3 text-xs text-[#687175] uppercase font-medium">Annee</th>
              <th className="text-right px-6 py-3 text-xs text-[#687175] uppercase font-medium">Tarif CERFA TICGN (EUR/MWh)</th>
              <th className="text-right px-6 py-3 text-xs text-[#687175] uppercase font-medium w-20">Actions</th>
            </tr>
          </thead>
          <tbody>
            {tarifs.map((t, index) => (
              <tr key={t.annee} className="border-t border-[#BFC6CC] hover:bg-[#F5F6F9]">
                <td className="px-6 py-4 font-mono font-semibold text-[#191D1E]">{t.annee}</td>
                <td className="px-6 py-4 text-right">
                  <input type="number" step="0.01" value={t.tarif} onChange={(e) => updateTarif(index, e.target.value)} className="w-32 text-right font-mono px-3 py-1.5 border border-[#BFC6CC] rounded-lg focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent" data-testid={`tarif-cerfa-ticgn-${t.annee}`} />
                </td>
                <td className="px-6 py-4 text-right">
                  <button onClick={() => removeAnnee(index)} className="p-1.5 text-red-500 hover:bg-red-50 rounded"><Trash2 className="w-4 h-4" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-4 flex items-center gap-3">
        <input type="text" placeholder="Ex: 2028" value={newAnnee} onChange={(e) => setNewAnnee(e.target.value)} className="w-32 font-mono px-3 py-2 border border-[#BFC6CC] rounded-lg" />
        <button onClick={addAnnee} disabled={!newAnnee} className="flex items-center gap-2 bg-white border border-[#BFC6CC] hover:bg-[#F5F6F9] text-[#191D1E] font-medium py-2 px-4 rounded-lg disabled:opacity-50">
          <Plus className="w-4 h-4" /> Ajouter une annee
        </button>
      </div>
    </div>
  );
};

export default AdminTarifsCerfaTicgn;
